import React from "react";
import UserProfile from "../../componentsGeneral/componentsSuperUser/userProfile/UserProfile";

const Profile = () => {
  return (
    <div>
      <UserProfile />
    </div>
  );
};

export default Profile;
